import AnalysisType from '../enums/AnalysisType'
import ViewOption from '../enums/InsightViewOption'
import MeasureType from '../enums/MeasureType'
import MetricCategory from '../enums/MetricCategory'
import { MetricItem } from '../enums/MetricItem'
import MetricCategoryItem from '../enums/MetricCategoryItem'
import MetricSeries from '../enums/MetricSeries'

export const getChildTypes = (analysisType, view, measureType) => {
  switch (view) {
    case ViewOption.OWNED_PARTNERED_EARNED:
      return MetricItem.CHILDREN_OPE
    case ViewOption.CHANNELS:
      return MetricItem.CHILDREN_CHANNELS
    case ViewOption.STAR_RATINGS:
      return MetricItem.CHILDREN_STAR_RATING
    case ViewOption.SURVEY_SCORES:
      return MetricItem.CHILDREN_SURVEY_SCORE
    case ViewOption.OVERVIEW:
    default:
      switch (measureType) {
        case MeasureType.POSTS:
          if (analysisType === AnalysisType.YT_SUMMARY) {
            return []
          }
          return [MeasureType.POST_VIDEOS, MeasureType.POST_IMAGES, MeasureType.POST_OTHER]
        case MeasureType.NET_SENTIMENT:
          return [MeasureType.POSITIVES, MeasureType.NEGATIVES]
        case MeasureType.MENTIONS:
          return MetricItem.CHILDREN_MENTIONS
        case MeasureType.UNIQUE_AUTHORS:
          if (analysisType === AnalysisType.YT_SUMMARY) {
            return []
          }
          return MetricItem.CHILDREN_AUTHORS
        case MeasureType.ENGAGEMENTS:
          if (analysisType === AnalysisType.YT_SUMMARY) {
            return [MeasureType.COMMENTS, MeasureType.LIKES, MeasureType.DISLIKES]
          }
          if (analysisType === AnalysisType.SW_NEW_SUMMARY) {
            return [MeasureType.COMMENTS, MeasureType.LIKES, MeasureType.SHARES, MeasureType.SCORE]
          }
          return MetricItem.CHILDREN_ENGAGEMENTS
        case MeasureType.OVERALL_STAR_RATINGS:
        case MeasureType.STAR_RATINGS:
          return MetricItem.CHILDREN_STAR_RATING
        case MeasureType.OVERALL_SURVEY_SCORES:
        case MeasureType.SURVEY_SCORES:
          return MetricItem.CHILDREN_SURVEY_SCORE
        case MeasureType.NET_PROMOTER_SCORES:
          return MetricItem.CHILDREN_NET_PROMOTER_SCORE
        case MeasureType.IMPRESSIONS:
        case MeasureType.PASSION_INTENSITY:
        case MeasureType.ENGAGEMENT_RATIO:
        default:
          return []
      }
  }
}

export const getParentTypes = (view, analysisType) => {
  let types = []
  switch (view) {
    case ViewOption.STAR_RATINGS:
    case ViewOption.SURVEY_SCORES:
      break
    case ViewOption.OWNED_PARTNERED_EARNED:
    case ViewOption.CHANNELS:
      if (AnalysisType.YT_SUMMARY === analysisType) {
        types = [
          MeasureType.POSTS,
          MeasureType.COMMENTS,
          MeasureType.LIKES,
          MeasureType.VIEWS,
          MeasureType.DISLIKES
        ]
      } else {
        types = [
          MeasureType.MENTIONS,
          MeasureType.POSTS,
          MeasureType.NET_SENTIMENT,
          MeasureType.POSITIVES,
          MeasureType.NEGATIVES,
          MeasureType.PASSION_INTENSITY,
          MeasureType.ENGAGEMENTS,
          MeasureType.COMMENTS,
          MeasureType.LIKES,
          MeasureType.SHARES,
          MeasureType.VIEWS,
          MeasureType.SCORE,
          MeasureType.ENGAGEMENT_RATIO,
          MeasureType.IMPRESSIONS,
          MeasureType.UNIQUE_AUTHORS
        ]
      }
      break
    case ViewOption.OVERVIEW:
    default:
      if (AnalysisType.YT_SUMMARY === analysisType) {
        types = [MeasureType.POSTS, MeasureType.ENGAGEMENTS, MeasureType.UNIQUE_AUTHORS]
      } else {
        types = [
          MeasureType.MENTIONS,
          MeasureType.POSTS,
          MeasureType.NET_SENTIMENT,
          MeasureType.PASSION_INTENSITY,
          MeasureType.ENGAGEMENTS,
          MeasureType.ENGAGEMENT_RATIO,
          MeasureType.IMPRESSIONS,
          MeasureType.UNIQUE_AUTHORS
        ]
      }
      break
  }
  if (AnalysisType.AM_NEW_SUMMARY === analysisType) {
    let index = types.indexOf(MeasureType.ENGAGEMENTS)
    if (index > -1) {
      types.splice(index, 1)
    }
    index = types.indexOf(MeasureType.ENGAGEMENT_RATIO)
    if (index > -1) {
      types.splice(index, 1)
    }
  }

  if (
    AnalysisType.SW_NEW_SUMMARY === analysisType
    // &&
    // TODO: nb.security.Permission.hasInternalAnalysisPermission()
  ) {
    switch (view) {
      case ViewOption.OVERVIEW:
        types = types.concat([
          MeasureType.OVERALL_STAR_RATINGS,
          MeasureType.OVERALL_SURVEY_SCORES,
          MeasureType.NET_PROMOTER_SCORES
        ])
        break
      case ViewOption.STAR_RATINGS:
        types = types.concat([MeasureType.STAR_RATINGS])
        break
      case ViewOption.SURVEY_SCORES:
        types = types.concat([MeasureType.SURVEY_SCORES])
        break
      default:
        break
    }
  }
  return types
}

export const getMetricCategory = (view) => {
  switch (view) {
    case ViewOption.OWNED_PARTNERED_EARNED:
      return MetricCategory.CONVERGED_MEDIA
    case ViewOption.CHANNELS:
      return MetricCategory.CHANNELS
    case ViewOption.OVERVIEW:
      return MetricCategory.OVERVIEW
    case ViewOption.STAR_RATINGS:
      return MetricCategory.STAR_RATINGS
    case ViewOption.SURVEY_SCORES:
      return MetricCategory.SURVEY_SCORES
    default:
      return undefined
  }
}

/**
 * @param {string} type
 * @return {string}
 */
export const getChildColor = (type) => {
  switch (type) {
    // Overview
    case MeasureType.POSITIVES:
    case MetricSeries.POSITIVE_SENTIMENT:
    case MetricCategoryItem.POSITIVES:
      return 'metricSeriesType.positiveSentiment'
    case MetricCategoryItem.MALE:
      return 'semantic.male'
    case MeasureType.NEGATIVES:
    case MetricSeries.NEGATIVE_SENTIMENT:
    case MetricCategoryItem.NEGATIVES:
      return 'sentiment.negative'
    case MetricCategoryItem.FEMALE:
      return 'semantic.female'
    case MetricCategoryItem.NEUTRALS:
    case MetricCategoryItem.UNKNOWN:
      return 'sentiment.neutral'

    // Converged Media
    case MetricCategoryItem.OWNED:
      return 'convergedMedia.owned'
    case MetricCategoryItem.PARTNERED:
      return 'convergedMedia.partnered'
    case MetricCategoryItem.EARNED:
      return 'convergedMedia.earned'

    // Domains
    case MetricCategoryItem.TWITTER:
      return 'sources.sourceTwitter'
    case MetricCategoryItem.FACEBOOK:
      return 'sources.sourceFacebook'
    case MetricCategoryItem.INSTAGRAM:
      return 'sources.sourceInstagram'
    case MetricCategoryItem.YOU_TUBE:
      return 'sources.sourceYoutube'
    case MetricCategoryItem.TIKTOK:
      return 'sources.sourceTikTok'
    case MetricCategoryItem.OTHER:
      return 'sources.sourceOther'

    // Post types
    case MeasureType.POST_VIDEOS:
      return 'measureType.postVideos'
    case MeasureType.POST_IMAGES:
      return 'measureType.postImages'
    case MeasureType.POST_OTHER:
      return 'measureType.postOther'

    // Engagements
    case MeasureType.ENGAGEMENTS:
      return 'measureType.engagements'
    case MeasureType.ENGAGEMENT_RATIO:
      return 'measureType.engagementRatio'
    case MeasureType.COMMENTS:
      return 'measureType.comments'
    case MeasureType.LIKES:
      return 'measureType.likes'
    case MeasureType.SHARES:
      return 'measureType.shares'
    case MeasureType.VIEWS:
      return 'measureType.views'
    case MeasureType.SCORE:
      return 'measureType.score'
    case MeasureType.DISLIKES:
      return 'measureType.dislikes'

    // Star rating
    case MetricCategoryItem.FIVE_STAR:
      return 'starRating.fiveStar'
    case MetricCategoryItem.FOUR_STAR:
      return 'starRating.fourStar'
    case MetricCategoryItem.THREE_STAR:
      return 'starRating.threeStar'
    case MetricCategoryItem.TWO_STAR:
      return 'starRating.twoStar'
    case MetricCategoryItem.ONE_STAR:
      return 'starRating.oneStar'
    case MetricCategoryItem.NO_RESPONSE_STAR:
      return 'starRating.noResponseStar'

    // Survey score
    case MetricCategoryItem.TEN_SCORE:
      return 'surveyScore.tenScore'
    case MetricCategoryItem.HIGH_SCORE:
      return 'surveyScore.highScore'
    case MetricCategoryItem.MEDIUM_SCORE:
      return 'surveyScore.mediumScore'
    case MetricCategoryItem.LOW_SCORE:
      return 'surveyScore.lowScore'
    case MetricCategoryItem.NO_SCORE:
      return 'surveyScore.noScore'
    case MetricCategoryItem.NO_RESPONSE_SURVEY:
      return 'surveyScore.noResponseSurvey'

    // Net promoter score
    case MetricCategoryItem.PROMOTER:
      return 'promoterScore.promoter'
    case MetricCategoryItem.PASSIVE:
      return 'promoterScore.passive'
    case MetricCategoryItem.DETRACTOR:
      return 'promoterScore.detractor'
    case MetricCategoryItem.NO_RESPONSE_NPS:
      return 'promoterScore.noResponseNPS'

    default:
      throw new Error(`Color undefined for child type ${type}`)
  }
}
